import React from 'react';
import { StyledSeparator } from './styles/Separator.styles';

const SeparatorControl = ({ control }) => (
  <StyledSeparator color={control.attributes.backgroundColor} />
);

export default SeparatorControl;